import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  connectionRunSchema,
  connectionRunListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/connectionRuns/actions';
import { ConnectionRunsActionTypes as types } from 'app/ducks/connectionRuns/types';

function* createConnectionRunSaga(action): any {
  yield put(sagaActions.createConnectionRunPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionRuns.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionRunSchema);
    history.push(`/competitions/${action.payload.competition.id}`);
    yield put(sagaActions.createConnectionRunSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createConnectionRunFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateConnectionRunSaga(action): any {
  yield put(sagaActions.updateConnectionRunPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionRuns.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionRunSchema);

    yield put(sagaActions.updateConnectionRunSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateConnectionRunFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getConnectionRunSaga(action): any {
  yield put(sagaActions.getConnectionRunPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionRuns.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, connectionRunSchema);
    yield put(sagaActions.getConnectionRunSuccess(normalizedResponse));
    return normalizedResponse.entities.connectionRuns[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getConnectionRunFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllConnectionRunsSaga(action): any {
  yield put(
    sagaActions.getAllConnectionRunsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.connectionRuns.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionRuns.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      connectionRunListSchema,
    );

    yield put(
      sagaActions.getAllConnectionRunsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllConnectionRunsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createConnectionRunSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_CONNECTION_RUN_REQUESTED,
    createConnectionRunSaga,
  );
}

function* updateConnectionRunSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_CONNECTION_RUN_REQUESTED,
    updateConnectionRunSaga,
  );
}

function* getConnectionRunSagaWatcher(): any {
  yield takeLatest(
    types.GET_CONNECTION_RUN_REQUESTED,
    getConnectionRunSaga,
  );
}

function* getAllConnectionRunsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_CONNECTION_RUNS_REQUESTED,
    getAllConnectionRunsSaga,
  );
}

export default function* root(): any {
  yield all([
    createConnectionRunSagaWatcher(),
    updateConnectionRunSagaWatcher(),
    getConnectionRunSagaWatcher(),
    getAllConnectionRunsSagaWatcher(),
  ]);
}
